import { Component } from 'react';
import { Card } from 'react-bootstrap';
import { connect } from 'react-redux';
import { actions, Control, Errors, Field, Form } from 'forms/rrf';
import { Link } from 'react-router-dom';
import ArrowButton from '../../common/button-arrow';
import { login as loginAction } from '../../../actions/login';
import ErrorMessages from '../error-messages';
import PasswordMaskInput from '../../common/form/elements/password-mask-input';
import IgniteUkLogo from '../../../assets/img/ignite_logo_black.png';
import './login-form.css';
import CookieConsent from '../../cookie-consent/cookie-consent';

class LoginForm extends Component {
  handleSubmit(payLoad) {
    const {dispatch} = this.props;
    dispatch(actions.submit('deep.login', loginAction(payLoad, dispatch)));
  }

  render() {
    return (
      <Form model="deep.login" onSubmit={login => this.handleSubmit(login)} className="login-form">
        <CookieConsent/>
        <Errors className="errors" component={ErrorMessages} model="deep.login"/>
        <Card className="login">
          <Card.Header>
            <div className="header-container">
              <img src={IgniteUkLogo} alt="Ignite UK" />
              <h2 className="text-uppercase login-title">
                Login
              </h2>
            </div>
          </Card.Header>
          <Card.Body>
            <Field className="form-group" model=".login">
              <label>
                E-mail or mobile:
              </label>
              <input className="form-control" type="text"/>
            </Field>

            <div className="form-group">
              <label>
                Password:
              </label>
              <Control
                component={PasswordMaskInput}
                model=".password"
              />
            </div>
            <div className="login-register-container">
              <ArrowButton color="red" ghost={false} arrow={false}>
                Login
              </ArrowButton>
              <Link to={'/registration/outlet'}>
                <ArrowButton
                  color="grey"
                  ghost={false}
                  arrow={false}
                  submit={false}
                  disabled={this.props.features.disable_outlet_registration}
                >
                  Register
                </ArrowButton>
              </Link>
            </div>
            <div className="remember-container">
              <label className="remember">
                <input type="checkbox"/>
                Remember me
              </label>
            </div>
            <div id="forgottenPasswordLabel" className="forgotten-password">
              Forgotten password?
              <Link to={'/reset-password'} className="forgotten-password-link">
                Click here
              </Link>
            </div>
          </Card.Body>
        </Card>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  login: state.deep.login,
  features: state.features || {}
});

export default connect(mapStateToProps)(LoginForm);
